module.exports = __webpack_public_path__ + "img/5.28bf111d.svg";